
<div class="display">
  <div class="acreage_top">
    <p class="summary">
      <span>Total Area: </span>
      <span>{{RecTotalArea}}</span>
    </p>
    <p class="summary">
      <span>Assigned Area: </span>
      <ng-container *ngIf="assignedArea">{{assignedArea}}</ng-container>
      <ng-container *ngIf="!assignedArea">0</ng-container>
    </p>
    <p class="summary">
      <span>Unassigned Area: </span>
      <span *ngIf="unAssignedArea">{{unAssignedArea}}</span>
    </p>
  </div>


<div class="toggle_view">
  <mat-button-toggle-group
name="fontStyle"
aria-label="Font Style"
color="accent"
class="m-3"

>
<mat-button-toggle value="list" color="accent" (click)="onList()"
  ><mat-icon class="example-tab-icon"
    >list</mat-icon
  ></mat-button-toggle
>
<mat-button-toggle value="grid" (click)="onGrid()"
  ><mat-icon class="example-tab-icon"
    >view_module</mat-icon
  ></mat-button-toggle
>
</mat-button-toggle-group>
</div>

<ng-container *ngIf="gridView">
  <form [formGroup]="individualAcreagesArrayForm" >
    <div class="main_entry">
      <div class="entry"
      *ngFor="let individual of individualAcreagesArrayForm.get('IndividualAcreages')['controls']; index as i"
        (click)="onEdit(individual.value, i)"
      >
        <p class="number">{{i + 1}}</p>
        <p class="info">
          <span>Terrain: </span>
          <span>{{getTerrainName(individual?.value.TerrainId)}}</span>
        </p>
        <p class="info">
          <span>Net Area: </span>
          <span>{{individual?.value.NetArea}}</span>
        </p>
        <p class="info">
          <span>Unit Of Measurement: </span>
          <span>{{getMeasureName(individual?.value.MeasureId)}}</span>
        </p>
        <p class="info">
          <span>Remark: </span>
          <span>{{individual?.value.Remarks}}</span>
        </p>
        <p class="info" (click)="$event.stopImmediatePropagation()">
          <i class="ti-trash" (click)="onDelete(individual.value, i)"></i>
        </p>

      </div>
      </div>
    </form>
</ng-container>
    </div>

    <div class="card mt-3 " *ngIf="listView">
      <div class="table-responsive">
      <table class="table table-hover" >
        <thead>
          <tr>
            <th scope="col">S/N</th>
            <th scope="col">Terrain</th>
            <th scope="col">Net Area</th>
            <th scope="col">Unit Of Measurement</th>
            <th scope="col">Remark</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody >
          <tr   *ngFor="let individual of individualAcreagesArrayForm.get('IndividualAcreages')['controls']; index as i"

          >
            <th scope="row">{{i + 1}}</th>
            <td>{{getTerrainName(individual?.value.TerrainId)}}</td>
            <td>{{individual?.value.NetArea}}</td>
            <td> {{getMeasureName(individual?.value.MeasureId)}}</td>
            <td>{{individual?.value.Remarks}}</td>
            <td (click)="$event.stopImmediatePropagation()" style="cursor: pointer; font-size: 1.5rem;">
              <i class="ti-pencil"  (click)="onEdit(individual.value, i)"></i>
              <i class="ti-trash" style="margin-left: 2rem;" (click)="onDelete(individual.value, i)"></i>
             </td>
          </tr>

        </tbody>
      </table>
    </div>
    </div>
